module.exports = __webpack_public_path__ + "img/download_white.076abab2.svg";